import React from 'react'
import OrderCardNew from './OrderCardNew'
import { Order } from '@/types'
import LoadingSpinner from '../LoadingSpinner'

interface OrdersGridProps {
  orders: Order[]
  onOrderClick?: (order: Order) => void
  isRTL?: boolean
  showLoadingIndicator?: boolean
  onConfirmPayment?: (order: Order) => void
  canConfirmPayment?: (order: Order) => boolean
}

const OrdersGrid: React.FC<OrdersGridProps> = ({
  orders,
  onOrderClick,
  isRTL = false,
  showLoadingIndicator = false,
  onConfirmPayment,
  canConfirmPayment,
}) => {
  if (orders.length === 0) {
    return null
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 pt-5 items-stretch">
      {orders.map((order) => (
        <OrderCardNew
          key={order.id}
          order={order}
          onCardClick={onOrderClick}
          isRTL={isRTL}
          onConfirmPayment={
            !canConfirmPayment || canConfirmPayment(order) ? onConfirmPayment : undefined
          }
        />
      ))}
      {showLoadingIndicator && (
        <div className="col-span-full flex flex-col justify-center items-center py-8 gap-3">
          <LoadingSpinner size="md" className="min-h-0" />
          <p className="text-sm text-gray-400 font-['IBM_Plex_Sans_Arabic'] font-medium">
            جاري تحميل المزيد من الطلبات...
          </p>
        </div>
      )}
    </div>
  )
}

export default OrdersGrid

